var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { scrollable: "", width: "1024px" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.asset
        ? _c(
            "v-card",
            { staticClass: "background" },
            [
              _c(
                "v-card-title",
                { staticClass: "px-2 py-1 title" },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.asset.ref_material) +
                      " | " +
                      _vm._s(_vm.asset.id) +
                      "\n\t\t\t"
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { flat: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.asset = null
                          _vm.show = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "background darken-1 pa-0" },
                [_c("Asset", { attrs: { asset: _vm.asset, tab: _vm.tab } })],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0db01c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0db01c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/globals/modal_asset.vue
// module id = null
// module chunks = 